import type {
  CostPaymentRecordKind,
  CostPaymentRecordParam,
} from "../../types";
import { getPaymentRecordKind } from "./paymentRecordFilters";

export type PaymentRecordSummary = {
  paid: number;
  claims: number;
  balances: number;
  leftToPay: number;
};

function sumByKind(
  records: CostPaymentRecordParam[],
  kind: CostPaymentRecordKind,
) {
  return records
    .filter((record) => getPaymentRecordKind(record) === kind)
    .reduce((sum, record) => sum + Math.max(record.amount, 0), 0);
}

/** Derive the ledger summary from the records currently returned by the API. */
export function summarizePaymentRecords(
  records: CostPaymentRecordParam[],
  patientResponsibility: number,
): PaymentRecordSummary {
  const paid = sumByKind(records, "payment");
  const claims = sumByKind(records, "claim");
  const balances = sumByKind(records, "balance");

  return {
    paid,
    claims,
    balances,
    leftToPay: Math.max(patientResponsibility + balances - paid, 0),
  };
}
